
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { FormSelect } from '@/components/forms/FormSelect';
import { SelectOption } from '@/components/forms/FormSelect';

interface TeacherAboutFieldsProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | any>) => void;
}

const TeacherAboutFields = ({ formData, handleChange }: TeacherAboutFieldsProps) => {
  // Employment type options
  const employmentTypeOptions: SelectOption[] = [
    { value: 'Full-time', label: 'Full-time' },
    { value: 'Part-time', label: 'Part-time' },
    { value: 'Contract', label: 'Contract' },
    { value: 'Temporary', label: 'Temporary' },
    { value: 'Consultant', label: 'Consultant' }
  ];

  // Handle employment type changes separately from other form fields
  const handleEmploymentTypeChange = (value: string) => {
    // Create a synthetic event-like object that matches what handleChange expects
    handleChange({
      target: { name: 'employmentType', value },
      currentTarget: { name: 'employmentType', value },
      nativeEvent: {} as any,
      bubbles: true,
      cancelable: true,
      defaultPrevented: false,
      isDefaultPrevented: () => false,
      isPropagationStopped: () => false,
      isTrusted: true,
      preventDefault: () => {},
      stopPropagation: () => {},
      persist: () => {},
      timeStamp: Date.now(),
      type: 'change'
    } as React.ChangeEvent<HTMLSelectElement>);
  };

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="employmentType">Employment Type</Label>
        <FormSelect
          name="employmentType"
          options={employmentTypeOptions}
          placeholder="Select employment type"
          onChange={handleEmploymentTypeChange}
          className="w-full"
          // Remove the value prop since FormSelect doesn't accept it directly
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="bio">About / Biography</Label>
        <Textarea
          id="bio"
          name="bio"
          placeholder="Enter teacher's biography, experience, and other relevant information"
          rows={5}
          value={formData.bio || ''}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default TeacherAboutFields;
